<template>
    <div class="modal-content">
        <div class="modal-body" style="overflow-y: auto;">
            <img src="../assets/img/profile-not-verified.svg" class="d-block m-auto" />
            <br />
            <h5 style="text-align: center;">Lakukan verifikasi identitas kamu</h5>
            <p style="text-align: center;">Kamu bisa mengakses bosAgen jika sudah berhasil melakukan verifikasi identitas.</p>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="signOut">Keluar</button>
            <button type="button" class="btn btn-primary" @click="openMobileApp">Verifikasi Sekarang</button>
        </div>
    </div>
</template>
<script>
    export default {
        emits: ['signOut'],
        methods: {
            signOut() {
                this.$emit('signOut');
            },
            openMobileApp() {
                const url = 'https://play.google.com/store/apps/details?id=com.boscod.agen';

                window.open(url, '_blank');
            }
        }
    }
</script>